import { MarkerLayout, MarkerLayoutSponsored, MarkerSize } from './styles';
import { Marker } from 'fronton-react';
import { BonusLogo } from '@fronton/icons-react/logos';
import React from 'react';

export const DATA_QA_LOYALTY_REWARDS_MARKER = 'loyalty-rewards-marker';

export type MarkerControllerProps = {
  isSponsored: boolean;
  loyaltyRewardLabel?: string;
  isSimplifiedVariant?: boolean;
};

export const MarkerStrategy = (props: MarkerControllerProps) => {
  const { isSponsored = false, loyaltyRewardLabel, isSimplifiedVariant } = props;

  if (isSponsored && isSimplifiedVariant) {
    return (
      <MarkerLayoutSponsored>
        <Marker
          data-qa={DATA_QA_LOYALTY_REWARDS_MARKER}
          iconLeft={<BonusLogo className={MarkerSize} />}
          background="secondary-red-dark"
          variant="angular"
          color="text-primary-invert"
          size="s"
          text={loyaltyRewardLabel}
        />
      </MarkerLayoutSponsored>
    );
  }

  return (
    <MarkerLayout>
      <Marker
        data-qa={DATA_QA_LOYALTY_REWARDS_MARKER}
        iconLeft={<BonusLogo className={MarkerSize} />}
        background="secondary-red-dark"
        variant="angular"
        color="text-primary-invert"
        size="s"
        text={loyaltyRewardLabel}
      />
    </MarkerLayout>
  );
};
